import React, { Component } from 'react';
import { Motion, spring } from 'react-motion';

import Button from '@material-ui/core/Button';
import Divider from '@material-ui/core/Divider';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import { withStyles } from '@material-ui/core/styles';


const styles = theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 1,
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 1
  },
  listItem: {
    display: 'flex',
    padding: '5px 0px',
  },
  yearButton: {
    width: '100%',
  },
  yearMenuItem: {
    width: '100px',
  }
});


class ScheduleTabs extends Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedYear: (new Date()).getFullYear(),
      anchorEl: null,
    };
  }

  handleClick = event => {
    this.setState({ anchorEl: event.currentTarget });
  };

  handleClose = () => {
    this.setState({ anchorEl: null });
  };

  render() {
    const { anchorEl, selectedYear } = this.state;
    const { classes, project, selectedItem, handleSelect } = this.props;
    const schedule = project.schedule;

    return(
      <div className={classes.root}>
        <div>
          <Button
            disabled = {project.years.length <= 1}
            className={classes.yearButton}
            color="primary"
            aria-owns={anchorEl ? 'year-menu' : null}
            aria-haspopup="true"
            onClick={this.handleClick}
          >
            {selectedYear}
          </Button>
          <Menu
            id="year-menu"
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            onClose={this.handleClose}
          >
            {project.years.map((year, i) => {
              return(
                <MenuItem
                  key={i}
                  className={classes.yearMenuItem}
                  onClick={() => {
                    //get first schedule item for the selected year
                    //then set year and schedule item
                    const scheduleItem = schedule.find((scheduleItem) => {
                      return scheduleItem.date.getFullYear() === year;
                    })
                    this.setState({anchorEl: null, selectedYear: year});
                    handleSelect(scheduleItem);
                  }}
                >{year}</MenuItem>
              )
            })}

          </Menu>
        </div>
        <Divider />
        <List className={classes.content}>
          {schedule.map((scheduleItem, i) => {
            //TODO: refact so that this does not use map. causes worning due to no key being set
            if(scheduleItem.date.getFullYear() === selectedYear){
              const isSelected = selectedItem === undefined ? false : scheduleItem.id === selectedItem.id;
              return (
                <List className={classes.listItem} key={i}>
                  <ListItem button dense onClick={() => handleSelect(scheduleItem)}>
                    <ListItemText primary={scheduleItem.displayName} />
                  </ListItem>
                  { isSelected &&
                    <Motion defaultStyle={{x: -20, y: -20, opacity: 0}}
                            style={{
                              x: spring(0),
                              y: spring(0),
                              opacity: spring(1, { stiffness: 10, damping: 10})
                            }}>
                      {(style) => (
                        <div style={{
                            opacity: style.opacity,
                            borderRight: '3px solid #3f50b5'
                        }}/>
                      )}
                    </Motion>
                  }
                </List>
              )
            } else {
              return null;
            }
          })}
        </List>
        <Divider />
      </div>
    );
  }
}

export default withStyles(styles)(ScheduleTabs);



// WEBPACK FOOTER //
// ./src/components/admin/Project/ScheduleTabs.jsx